import React, { Component } from "react";
import { Link } from "react-router-dom";
import * as styles from "./authentication.styles";
import { css } from "react-emotion";
import { withRedux, displayError } from "helpers";
import { Button } from "appStyles";

const container = css`
  display: flex;
  position: absolute;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 0.5em;
  width: 100%;
  height: 85%;
`;

const wrapper = css`
  margin: 0 auto;
  float: none;
  background-color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  @media only screen and (min-width: 768px) {
    width: 500px;
  }
  width: 100%;
`;
const col = css`
  flex: 0 0 92%;
  margin: auto 4%;
  @media only screen and (min-width: 480px) {
    margin-left: 4%;
    margin-right: 0%;
    text-align: center;
  }
`;

const col1 = css`
  @media only screen and (min-width: 768px) {
    text-align: center;
  }
  @media only screen and (min-width: 300px) {
    text-align: center;
  }
`;
const row = css`
  display: flex;
  flex-flow: row wrap;
  flex: 0 1 auto;
  padding: 5px 10px;
  margin-bottom: 35px;
`;

const form = css`
  background: white;
  padding: 1em;
`;

class ForgotPassword extends Component {
  state = {
    password: "",
    confirmPassword: "",
    passwordHasReset: false,
  };

  submit = (e) => {
    e.preventDefault();
    const { password, confirmPassword } = this.state;

    if (password !== confirmPassword)
      return displayError("Passwords need to match.");
    if (!password) return displayError(`Password can't be empty.`);

    this.props.actions
      .resetPassword(this.getResetToken(), password)
      .then((res) => {
        this.setState({ passwordHasReset: true });
      });
  };

  getResetToken = () => {
    return new URLSearchParams(this.props.location.search).get("token");
  };

  update = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  renderResetPasswordContent = () => {
    const { passwordHasReset, password, confirmPassword } = this.state;

    if (passwordHasReset) {
      return (
        <div>
          <p className={styles.message}>
            Great! You have successfully changed your password.
          </p>
          <Link className={styles.unStyledButton} to="/">
            Continue to login
          </Link>
        </div>
      );
    }

    return (
      <React.Fragment>
        <input
          type="password"
          className={styles.inputStyle}
          placeholder="Password"
          name="password"
          onChange={this.update}
          value={password}
          style={{ margin: "10px" }}
        />
        <br />
        <input
          type="password"
          className={styles.inputStyle}
          placeholder="Confirm Password"
          name="confirmPassword"
          onChange={this.update}
          value={confirmPassword}
          style={{ margin: "10px" }}
        />
        <Button onClick={this.submit}>Reset Password</Button>
      </React.Fragment>
    );
  };

  render() {
    return (
      <div className={wrapper}>
        <div className={row}>
          <div className={col + " " + col1}>
            <form className={form} onSubmit={this.submit}>
              <h1>Reset Password</h1>
              {this.renderResetPasswordContent()}
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default withRedux(ForgotPassword);
